/**
* In this file contains the webcam stream popup
**/
import { Modal,Button } from 'react-bootstrap';
import {useState,useRef} from 'react';
import Webcam from 'react-webcam';
import constantVariables from './../../dataset/constantVariables.json';

function CameraModal(props) {
	
	//Intial state declaration
	const webcamRef = useRef(null);
	const [imageData, setImageData] = useState(null);
	const [showCamera, setShowCamera] = useState(true);
	
	//To handle capturing the image
	const captureImage = () => {
		const imageSrc = webcamRef.current.getScreenshot();
		setShowCamera(false);
		setImageData(imageSrc);
	};
  
	//To handle retaking the image
	const retakeImage = () => {
		setShowCamera(true);
		setImageData(null);
    };
	 
	//To callback function for close camera modal
	const closeModal = () => {
		props.handleClose();
	}
	
	//To handle send the  message 
	const sendImage = () => {
		if(imageData){
			props.handleImageCapture(imageData);
			closeModal();
		}
	};
	
	return (
	<Modal 
		show={props.show}
		onHide={closeModal}
		backdrop="static"
		keyboard={false}
		size="md"
		aria-labelledby="contained-modal-title-vcenter"
		centered
	>
		<Modal.Header closeButton>
			<Modal.Title>{constantVariables.modal.cameraModal}</Modal.Title>
		</Modal.Header>
		<Modal.Body>
		<div>
		    {showCamera && (
			  <div>
			    {/* import Webcam component */}
			    <Webcam
				  audio={false}
				  ref={webcamRef}
				  screenshotFormat="image/jpeg"
			    />
			  </div>
		    )}

		    {/* Show the captured image */}
		    {!showCamera && (
			  <div>
			    <img src={imageData} alt="Captured" />
			  </div>
		    )}
		</div>
	</Modal.Body>
	{/*Footer*/}
	<Modal.Footer>
		<div className="d-flex">
			{showCamera ? (
			<Button variant="secondary" onClick={captureImage} className="mx-2">
				Capture
			</Button>
			) : (
			<div>
				<Button variant="secondary" onClick={retakeImage} className="mx-1">Retake</Button>
				<Button variant="secondary" onClick={sendImage} className="mx-2">Send</Button>
			</div>
			)}
			<Button variant="secondary" onClick={closeModal}>
				Close
			</Button>	
		</div>
	</Modal.Footer>
	{/*End Footer*/}
	</Modal>
	);
}

export default CameraModal;
